import { ARTICLE_CONDENSED_TEXT_HEIGHT, ARTICLE_TEXT_HEIGHT, ARTICLE_TEXT_HEIGHT_RATING, ARTICLE_TEXT_HEIGHT_TABLET, ListStyleType } from '../helpers';
const sum = numbers => numbers.reduce((a, b) => {
  return a + b;
}, 0);
export const getArticleHeight = ({
  hideRating,
  mode
}) => sum([mode === ListStyleType.condensed ? ARTICLE_CONDENSED_TEXT_HEIGHT : ARTICLE_TEXT_HEIGHT, !hideRating ? ARTICLE_TEXT_HEIGHT_RATING : 0]);
export const getArticleHeightTablet = ({
  hideRating,
  mode
}) => sum([mode === ListStyleType.condensed ? ARTICLE_CONDENSED_TEXT_HEIGHT : ARTICLE_TEXT_HEIGHT_TABLET, !hideRating ? ARTICLE_TEXT_HEIGHT_RATING : 0]);